import $ from "jquery"

// Talent section
$('.js-talent-list-item').each(function(){
    $(this).on('click', function(){
        const dataId = $(this).data('id');
        const videoElement = document.querySelector('.talent__content--' + dataId + ' .talent__video');
        const gifElementData =  $('.talent__content--' + dataId).data('gif');

        $('.js-talent-list-item').removeClass('item-active');
        $('.js-talent-list-content').removeClass('content-active');
        $('.js-talent-gif').removeAttr('src');

        $('.talent__content--' + dataId).addClass('content-active');
        $('.talent__content--' + dataId + ' .js-talent-gif').attr('src', gifElementData);
        $(this).addClass('item-active');

        videoElement.currentTime = 0;
        videoElement.play();
    });
});